<svelte:options tag="fds-pose-editor" />
<script>
    import { onMount } from "svelte"
    import fdsHelper from "@fds-components/fds-helper"
    let path = fdsHelper.get_href()
    import {get_current_component, select_option} from "svelte/internal"
    let host = get_current_component()
    import { version as componentversion, name } from "../package.json"
    /*global BABYLON */

    /**
     * width of canvas
     * @type {integer}
     */
    export let width=1000
    /**
     * height of canvas
     * @type {integer}
     */    
    export let height=1000
    /**
     * turn human figure on/off
     *  @type {boolean}
     */
    let showHuman=true
    /**
     * object with data property to save scene on destroy 
     */
    export let external_scene_storage=null

    
    /** show character or not, human supported only
     * @param  {("human" | "")} 
     */
    export let show_character="human"

    /**
     * make camera movement lock
     * @param  {("lock" | "")} 
     */
    export let camera_behaviour=""
    /**
     * Get information about component
     * @param  {("api" | "examples" | "css")} type the info type
     */
    export async function getInfo(type) {
        if (type === "version") {
            return new Promise((resolve) => {
                resolve(componentversion);
            });
        }
        let res = await fdsHelper.getInfo(type, name);
        return res;
    }

    /**
     * version of component
     * @type {string}
     */
    export const version = componentversion;
    function _destroy() {
        if (!external_scene_storage) return
        external_scene_storage.data=getSceneNoImage()
    }

    onMount(() => {
        setTimeout(async () => {
            while (window.in_3d_canvas_init) {
                await new Promise(r => setTimeout(r, 100));
            }
            window.in_3d_canvas_init=true
            initCanvas(canvas)
         },0)
        return () => {
            _destroy()
        }
    })   
    
    $: {
        if (canvas) {
         //   initCanvas(canvas)
        } 
       
    }
    $: {    
        if (show_character=="human") {
            showHuman=true
        } else {
            showHuman=false
        }
        showMeshes(loadedMeshes,showHuman)         
    }
    $: {
        if (background_type) setBackground(background_type)
    }
    $: {
        if (mode) setMode(mode)
    }
    $: {
        if (scene) {
            if (!camera_behaviour)      scene.activeCamera.attachControl(canvas, true)
            if (camera_behaviour==="lock")        scene.activeCamera.detachControl()
        }
    }
    let engine
    export let scene    // for scene.activeCamera access
    let meshFigure
    let loadedMeshes=[]
    /**
     * get points for a circle (=shape of each bone)
     * @param radius
     * @param numSegments
     */
    function getCirclePoints(radius, numSegments) {
        let points = []
        for (let i = 0; i < numSegments; i++) {
            let angle = (i / numSegments) * Math.PI * 2
            let x = radius * Math.cos(angle)
            let y = radius * Math.sin(angle)
            points.push(new BABYLON.Vector3(x, y, 0))
        }
        return points
    }
    function getRotationAxis(but) {
        let rotationAxis
            switch (but) {
                case "x":
                    rotationAxis = BABYLON.Axis.X
                    break;
                case "y":
                    rotationAxis = BABYLON.Axis.Y
                    break;
                case "z":
                    rotationAxis = BABYLON.Axis.Z
                    break;
            }   
            return rotationAxis
    } 
    function startRenderLoop(engine) {
            engine.runRenderLoop(function () {
                if (scene && scene.activeCamera) {
                    if (rotationGizmoActive &&  mode==="edit_skeleton") {

                     //   var worldMatrix = proxySphere.getWorldMatrix();
/*var quatRotation =  new BABYLON.Quaternion();
var position = new BABYLON.Vector3();
var scale = new BABYLON.Vector3();
worldMatrix.decompose(scale, quatRotation, position);                        
let euler=quatRotation.toEulerAngles()*/

                   //     proxySphere.computeWorldMatrix(true)
                        let newRotationValue=proxySphere.rotation[currentAxis]
//console.log(euler,proxySphere)

 //                       if (currentAxis==="x") newRotationValue*=100
                  //      let rotQ=proxySphere.rotationQuaternion
                   //     let newRotationValue=rotQ.toEulerAngles()[currentAxis]
                       let dt=currentRotationValue-newRotationValue
                   //     pickedTransformNode.rotate(getRotationAxis(currentAxis), dt, BABYLON.Space.WORLD)
                        currentRotationValue=newRotationValue
                     //   if (dt) console.log(currentAxis,dt,newRotationValue)
//                        const centerLocalRotation = parentBox.rotation.clone().negateInPlace().add(centerWorldRotation);
 //   const centerReWorldRotation = BABYLON.Vector3.TransformCoordinates(centerLocalRotation.clone(), parentWorldMatrix)                        
                       // if (currentJointName==="joint_LowerLeg L" || currentJointName==="joint_LowerLeg R") {
                       //     pickedTransformNode.rotation=new BABYLON.Vector3(-z,y,x)                        
                       // } else {
                      //      pickedTransformNode.rotation=new BABYLON.Vector3(x,y,z)                        

                       // }

                 /*      let worldRotationQuat = BABYLON.Quaternion.FromEulerVector(proxySphere.rotation);
                       console.log(pickedTransformNode.parent)
 var worldMatrix = pickedTransformNode.parent.getWorldMatrix();                       
var quatRotation =  new BABYLON.Quaternion();
var position = new BABYLON.Vector3();
var scale = new BABYLON.Vector3();
worldMatrix.decompose(scale, quatRotation, position);             


                        let rotationQuaternion = worldRotationQuat.multiply(BABYLON.Quaternion.Inverse(quatRotation))                        
                        pickedTransformNode.rotation=rotationQuaternion.toEulerAngles()*/

                    }


                    scene.render()
                }
            });
        }
    let wait = function () {
        var promise = new Promise((resolve) => {
            setTimeout(() => {
                resolve('')
            }, 100)
        })
        return promise
    }        
    export async function renderForAI() {
      //  canvas.width=width
     //   canvas.height=height        
        setMode("")
        let backgroundBack=background_type
        setBackground("black")
        let showH=show_character
        show_character=""
        for(let mesh of scene.meshes) {
            if (mesh.renderForAI) {
                mesh.material.disableLighting = true
                mesh.material.emissiveColor = mesh.aiColor
            }
        }
        await wait()
        show_character=showH
        let url=canvas.toDataURL()     
        for(let mesh of scene.meshes) {
            if (mesh.renderForAI) {
                mesh.material.disableLighting = false
                mesh.material.emissiveColor =BABYLON.Color3.FromHexString("#000000")  
            }
        }        
        setBackground(backgroundBack)

        return url
    }
    let skeletonInfo={
        "top": { boneColor:"#00009b",jointColor:"#9e323a" },
        "Shoulder L": { boneColor:"#993300",jointColor:"" },
        "Shoulder R": { boneColor:"#990000",jointColor:"" },
        "UpperArm L": { boneColor:"#669900",jointColor:"#349c00" },
        "UpperArm R": { boneColor:"#996600",jointColor:"#916100" },
        "LowerArm L": { boneColor:"#339900",jointColor:"#008400" },
        "LowerArm R": { boneColor:"#999900",jointColor:"#9a9900" },
        "Wrist L": { boneColor:"#009999",jointColor:"" },
        "Wrist R": { boneColor:"#009900",jointColor:"" },                
        "UpperLeg L": { boneColor:"#006699",jointColor:"#003194" },
        "UpperLeg R": { boneColor:"#009933",jointColor:"#00a767" },
        "LowerLeg L": { boneColor:"#003399",jointColor:"#0011b3" },
        "LowerLeg R": { boneColor:"#009966",jointColor:"#00a49d" },


        // head
        "Eye L": { boneColor:"#a200a3",jointColor:"#9f002e" },
        "Eye R": { boneColor:"#320099",jointColor:"#9f002e" },
        "Ear L": { boneColor:"#990066",jointColor:"#980098" },
        "Ear R": { boneColor:"#660099",jointColor:"#6a009f" }, 
        "Delete L": { boneColor:"",jointColor:"#980032" },
        "Delete R": { boneColor:"",jointColor:"#9c006a" },
        "Hand L": { boneColor:"",jointColor:"#009933" },
        "Hand R": { boneColor:"",jointColor:"#669900" },
        "Foot L": { boneColor:"",jointColor:"#330098" },
        "Foot R": { boneColor:"",jointColor:"#006598" },        
    }
    /**
     * render skeleton
     * @param mesh
     * @param skeleton
     */        
    function addSkeleton(mesh,skeleton) {

        let spheres = []
    //    skeleton.prepare()

        skeleton.bones.forEach(function (bone) {
            if (
                !bone.name.includes("neutral") &&
                !bone.name.includes("Skelett") 
            ) {
                let info=skeletonInfo[bone.name]
                let color="#FF0000"
                if  (!bone.name.includes("Wrist") && !bone.name.includes("Shoulder")  && !bone.name.includes("Finger")   && !bone.name.includes("Thumb")) {
                 
                    const sphere = BABYLON.MeshBuilder.CreateSphere( "joint_" + bone.name, { segments: 4, diameter: .04 },   scene)
                    sphere.attachToBone(bone, mesh)
                    sphere.bone = bone
                    sphere.renderingGroupId = 2
                
                    if (info && info.jointColor) color=info.jointColor
                    sphere.material = new BABYLON.StandardMaterial("joint")
                    sphere.material.diffuseColor = BABYLON.Color3.FromHexString(color)
                    
                    sphere.renderForAI=true
                    sphere.aiColor=BABYLON.Color3.FromHexString(color)        
                            
                    spheres.push(sphere)            
                }
                let path = []
                let child
                if (bone.children && bone.children[0]) {
                    child = bone.children[0];
                    path = [
                        new BABYLON.Vector3(0, 0, 0),
                        child.position,
                    ];
                } else {
                    //  console.log("no children", bone.name, bone)
                }
                color="#ffffff"
                if (info && info.boneColor) color=info.boneColor

                let circle = getCirclePoints(.015, 5)
                let extrusion
                if (path.length  && !bone.name.includes("Finger")   && !bone.name.includes("Thumb") && !bone.name.includes("Hand")) {
                    extrusion = new BABYLON.MeshBuilder.ExtrudeShape(
                        "bone_" + bone.name,
                        {
                            shape: circle,
                            closeShape: true,
                            path: path,
                            sideOrientation: BABYLON.Mesh.DOUBLESIDE,
                            updatable: true,
                        },
                        scene
                    )

                    extrusion.renderingGroupId = 2
                    extrusion.bone = bone
                    extrusion.child = child
                    extrusion.attachToBone(bone, mesh)
                    extrusion.material = new BABYLON.StandardMaterial("bone")
                    extrusion.renderForAI=true
                    extrusion.aiColor=BABYLON.Color3.FromHexString(color)  
                    extrusion.material.diffuseColor = BABYLON.Color3.FromHexString(color)  

                    
                }
            }
        })

    }
    let positionData={
        joints:{},
        root:{}
    }
    function saveJointPositions() {
        const position = BABYLON.Vector3.Zero()
        const scaling = BABYLON.Vector3.Zero()
        const rotationQ = BABYLON.Quaternion.Zero()     
        let lmat=root.getLocalMatrix()
        lmat.decompose(scaling, rotationQ, position)                
        positionData.root={scaling:scaling.clone(),rotationQ:rotationQ.clone(),position:position.clone()}
  
        for(let mesh of scene.meshes) {
            if (mesh.name.includes("joint_")) {
                let bone=mesh.bone
                let lmat=bone.getLocalMatrix()
                lmat.decompose(scaling, rotationQ, position)                

                positionData.joints[mesh.name]={scaling:scaling.clone(),rotationQ:rotationQ.clone(),position:position.clone()}
            }
        }   
    }
    function restoreJointPositions() {
        let node=root.getTransformNode()
        let info=positionData.root
        node.rotationQuaternion=new BABYLON.Quaternion(info.rotationQ._x,info.rotationQ._y,info.rotationQ._z,info.rotationQ._w)
        node.position=new BABYLON.Vector3(info.position._x,info.position._y,info.position._z)                
        node.scaling=new BABYLON.Vector3(info.scaling._x,info.scaling._y,info.scaling._z)  
        for(let mesh of scene.meshes) {
            if (mesh.name.includes("joint_")) {
                let bone=mesh.bone
                node=bone.getTransformNode()

                info=positionData.joints[mesh.name]
                node.rotationQuaternion=new BABYLON.Quaternion(info.rotationQ._x,info.rotationQ._y,info.rotationQ._z,info.rotationQ._w)
                node.position=new BABYLON.Vector3(info.position._x,info.position._y,info.position._z)                
                node.scaling=new BABYLON.Vector3(info.scaling._x,info.scaling._y,info.scaling._z)  

                if (node.rotationQuaternion) {
                    bone.rotationQuaternion = node.rotationQuaternion;
                } else {
                    bone.rotation = node.rotation;
                }
                bone.scaling = node.scaling;
            }
        }   
    }    
    /**
     * load current pose
     * return: position object
     */
    export function getPose() {
        saveJointPositions()
        let res=[JSON.parse(JSON.stringify(positionData))]
        return res
    }
    /**
     * set current pose
     * @param positionArray
     */
     export function setPose(positionArray) {
        positionData=positionArray[0]
        restoreJointPositions()
    }
    /**
     * get full scene data: camera and all poses
     */
    export async function getScene() {
        let image=await renderNormal()
        let cameraInfo={}
        let camera=scene.activeCamera
        cameraInfo.position=JSON.parse(JSON.stringify(camera.position))
        cameraInfo.rotation=JSON.parse(JSON.stringify(camera.rotation))
        let poseInfo= getPose()
        return {cameraInfo,poseInfo,image}
    }
    /**
     * get full scene data: camera and all poses without image
     */
     export function getSceneNoImage() {
        let cameraInfo={}
        let camera=scene.activeCamera
        cameraInfo.position=JSON.parse(JSON.stringify(camera.position))
        cameraInfo.rotation=JSON.parse(JSON.stringify(camera.rotation))
        let poseInfo= getPose()
        return {cameraInfo,poseInfo}
    }

    /**
     * set scene and pose data
     */
    export function setScene(sceneInfo) {
        if (!root) {    // model might not be loaded yet - does not happen very often
            setTimeout(() => {
                setPose(sceneInfo.poseInfo)
                let camera=scene.activeCamera
                camera.position=sceneInfo.cameraInfo.position
                camera.rotation=sceneInfo.cameraInfo.rotation        
            },500)
        } else {
            setPose(sceneInfo.poseInfo)
            let camera=scene.activeCamera
            camera.position=sceneInfo.cameraInfo.position
            camera.rotation=sceneInfo.cameraInfo.rotation        
        }
    }

    /**
     * make image from current scene for pose save
     * @return: base64-url
     */
    export async function renderNormal() {
        let oldMode=mode       
        setMode("")
        await wait()
        let url=canvas.toDataURL()             
        setMode(oldMode)
        return url
    }
    /**
     * current mode
     * @param  {("edit_skeleton" | "move_rotate"  | "scale" | "")} 
     */
    export let mode=""
    export function setMode(newMode) {
        if (newMode==="edit_skeleton" && rotationGizmo && positionGizmo) {
            if (rotationGizmo) rotationGizmo.attachedNode =null
            if (positionGizmo) positionGizmo.attachedNode =null
            if (scaleGizmo) scaleGizmo.attachedNode =null
            if (axisScaleGizmo) axisScaleGizmo.attachedNode=null
        }
        if (newMode==="move_rotate" && root) {
            rotationGizmo.attachedNode=root.getTransformNode()
            positionGizmo.attachedNode=root.getTransformNode()
            if (scaleGizmo) scaleGizmo.attachedNode =null
            if (axisScaleGizmo) axisScaleGizmo.attachedNode=null
        }
        if (newMode==="scale" && rotationGizmo && positionGizmo) {
            rotationGizmo.attachedNode =null
            positionGizmo.attachedNode =null           
            if (axisScaleGizmo) axisScaleGizmo.attachedNode=null
            if (scaleGizmo) scaleGizmo.attachedNode =root.getTransformNode()
        }        
        if (newMode==="" && rotationGizmo && positionGizmo) {
            rotationGizmo.attachedNode =null
            positionGizmo.attachedNode =null            
            scaleGizmo.attachedNode =null
            if (axisScaleGizmo) axisScaleGizmo.attachedNode=null
        }           
    }


    function dispatchChange(info) {
        host.dispatchEvent( new CustomEvent("change",{detail:info}))
    }
    let rotationGizmo
    let positionGizmo
    let scaleGizmo
    let axisScaleGizmo
    let root
    let pickedTransformNode
    let rotationGizmoActive=false
    let proxySphere
    let currentJointName
    let currentAxis
    let currentRotationValue
    /**
     * add Gizmos to joints and main body for rotation
     * @param bodyMeshes
     */
    function addGizmo(bodyMeshes,skeleton) {
        //proxySphere = BABYLON.MeshBuilder.CreateSphere( "proxy" , { segments: 4, diameter: .06 },   scene)

         proxySphere = BABYLON.MeshBuilder.CreateBox("box", {height: 0.06, width: 0.06, depth: .06});

        proxySphere.renderingGroupId = 2
        proxySphere.isVisible=false


        root=skeleton.bones[0]
        // Create utility layer the gizmo will be rendered on
        let utilLayer = new BABYLON.UtilityLayerRenderer(scene);
        // position Gizmo
        positionGizmo=new BABYLON.PositionGizmo(utilLayer)
        // Create the gizmo and attach to the box
        rotationGizmo = new BABYLON.RotationGizmo(utilLayer)

        scaleGizmo = new BABYLON.ScaleGizmo(utilLayer)

        positionGizmo.xGizmo.dragBehavior.onDragEndObservable.add(() => {
            dispatchChange({type:"position",axis:"x"})
        })
        positionGizmo.yGizmo.dragBehavior.onDragEndObservable.add(() => {
            dispatchChange({type:"position",axis:"y"})
        })       
        positionGizmo.zGizmo.dragBehavior.onDragEndObservable.add(() => {        
            dispatchChange({type:"position",axis:"z"})
        })           
        
        
        /**
         * rotation
        */
        rotationGizmo.xGizmo.dragBehavior.onDragEndObservable.add(() => {
            rotationGizmoActive=false
            proxySphere.isVisible=false
            dispatchChange({type:"rotation",axis:"x"})
        })
        rotationGizmo.yGizmo.dragBehavior.onDragEndObservable.add(() => {
            rotationGizmoActive=false
            proxySphere.isVisible=false
            dispatchChange({type:"rotation",axis:"y"})
        })   

        rotationGizmo.zGizmo.dragBehavior.onDragEndObservable.add(() => {
            rotationGizmoActive=false
            proxySphere.isVisible=false
            dispatchChange({type:"rotation",axis:"z"})
        })   
        rotationGizmo.xGizmo.dragBehavior.onDragStartObservable.add(() => {
            currentAxis="x"
            currentRotationValue=proxySphere.rotation[currentAxis]
            rotationGizmoActive=true
        })
        rotationGizmo.yGizmo.dragBehavior.onDragStartObservable.add(() => {
            currentAxis="y"
            currentRotationValue=proxySphere.rotation[currentAxis]
            rotationGizmoActive=true
        })   

        rotationGizmo.zGizmo.dragBehavior.onDragStartObservable.add(() => {
            currentAxis="z"
            currentRotationValue=proxySphere.rotation[currentAxis]
            rotationGizmoActive=true
        })   




        scaleGizmo.xGizmo.dragBehavior.onDragEndObservable.add(() => {
            dispatchChange({type:"scale",axis:"x"})
        })
        scaleGizmo.yGizmo.dragBehavior.onDragEndObservable.add(() => {
            dispatchChange({type:"scale",axis:"y"})
        })   
        scaleGizmo.zGizmo.dragBehavior.onDragEndObservable.add(() => {
            dispatchChange({type:"scale",axis:"z"})
        })   
        let axisScaleGizmo = new BABYLON.AxisScaleGizmo(new BABYLON.Vector3(0,1,0), BABYLON.Color3.FromHexString("#00b894"), utilLayer);
        axisScaleGizmo.attachedNode=null
        // Keep the gizmo fixed to world rotation
        rotationGizmo.updateGizmoRotationToMatchAttachedMesh = true
        rotationGizmo.updateGizmoPositionToMatchAttachedMesh = true

        positionGizmo.updateGizmoPositionToMatchAttachedMesh = true        
        currentJointName=""
        scene.onPointerDown = function () {
            const pickInfo = scene.pick(this.pointerX, this.pointerY)
            if (pickInfo.hit && mode==="edit_skeleton") {
                if (pickInfo.pickedMesh.name.includes("joint_")) {
                    let jointMesh=pickInfo.pickedMesh
                    if (jointMesh.name===currentJointName) {
                        rotationGizmo.attachedNode =null
                        currentJointName=""
                    } else {
                        currentJointName=jointMesh.name
                        rotationGizmo.jointMesh=jointMesh
                        pickedTransformNode=jointMesh.bone.getTransformNode()
                        proxySphere.position=jointMesh.bone.getTransformNode().absolutePosition
             //           proxySphere.rotation=pickedTransformNode.rotation
                        proxySphere.isVisible=false
                        rotationGizmo.attachedNode =pickedTransformNode
                        axisScaleGizmo.attachedNode=null

//                        proxySphere.parent=jointMesh
//                        proxySphere.rotation=pickedTransformNode.rotation
                        var worldMatrix = pickedTransformNode.getWorldMatrix();
var quatRotation =  new BABYLON.Quaternion();
var position = new BABYLON.Vector3();
var scale = new BABYLON.Vector3();
worldMatrix.decompose(scale, quatRotation, position);                        
let euler=quatRotation.toEulerAngles()
proxySphere.rotation=euler

                    }                    
                }
                // change bone length
                if (pickInfo.pickedMesh.name.includes("bone_")) {

                 //   let bone = pickInfo.pickedMesh.bone
                 //   rotationGizmo.attachedNode=null
                 //   axisScaleGizmo.attachedNode=  bone.getTransformNode()
                }
            }
        }
    }
    export async function getPoseFromImage(imgTag) {
        const pose =await new  Pose({locateFile: (file) => {
            return `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`;
        }});
        console.log(pose)
        await pose.setOptions({
  modelComplexity: 1,
  smoothLandmarks: true,
  enableSegmentation: true,
  smoothSegmentation: true,
  minDetectionConfidence: 0.5,
  minTrackingConfidence: 0.5
});
pose.onResults((results) => {

    console.log("RES", results)
 })
 await pose.reset()
 console.log("send noch")
       await  pose.send({ image:imgTag })

       // console.log("pose",pose)
    }
    /**
     * show/hide all meshes from an array
     * @param meshes
     * @param enable
     */
    function showMeshes(meshes,enable) {
        if (!meshes) return
        for(let mesh of meshes) {
                if (enable) mesh.visibility=1.0
                else mesh.visibility=0.00001        // 0.0 does not work because it deactivates skeleton
        }
    }
    /**
     * default skeleton viewer - only for debugging
     * @param mesh
     * @param skeleton
     */
    export function addSkeletonViewer(mesh,skeleton) {
       let skeletonViewer = new BABYLON.Debug.SkeletonViewer(
                    skeleton,
                    mesh,
                    scene
                )
        skeletonViewer.isEnabled = true; // Enable it
        skeletonViewer.color = BABYLON.Color3.Red(); // Change default color from white to red*/
    }
    /**
     * set background to grey or transparent
     */
    export let background_type="transparent"

    let background=null
    /**
     * set background
     * @param ("grey"|"transparent"|"black")
    */
    export function setBackground(type="grey") {
        if (!scene) return
        if (type==="transparent") {
            if (background) {
                background.dispose()
                background=null
            }
            scene.clearColor = new BABYLON.Color4(0, 0, 0, 0)
        }
        if (type==="grey") {
            if (!background) {
                background  = scene.createDefaultEnvironment({ enableGroundShadow: true  })
                background.setMainColor(BABYLON.Color3.Gray())
                background.ground.position.y += 0.01    
            }
            scene.clearColor=clearColorDefault
        }
        if (type==="black") {
            if (background) {
                background.dispose()
                background=null
            }
            scene.clearColor= new BABYLON.Color4(0, 0, 0, 255)
        }
    }

    let clearColorDefault
    function initCanvas(canvas) {
        engine = new BABYLON.Engine(canvas, true, {
            preserveDrawingBuffer: true,
            stencil: true,
        })
        engine.enableOfflineSupport = false
        engine.resize()
        // This is really important to tell Babylon.js to use decomposeLerp and matrix interpolation
        BABYLON.Animation.AllowMatricesInterpolation = true

        scene = new BABYLON.Scene(engine)
        clearColorDefault=scene.clearColor
        // var camera = new BABYLON.ArcRotateCamera("camera1", Math.PI / 2, Math.PI / 4, 3, new BABYLON.Vector3(0, 1, 0), scene);
        let camera = new BABYLON.ArcRotateCamera("camera1",Math.PI / 2,Math.PI / 2, 3,new BABYLON.Vector3(0, 1, 0),scene)
        camera.attachControl(canvas, true)
        camera.lowerRadiusLimit = 1.2
        camera.upperRadiusLimit = 8
        camera.wheelDeltaPercentage = 0.01
        camera.onViewMatrixChangedObservable.add(() => {
                dispatchChange({type:"camera",position:camera.position,rotation:camera.rotation})
        })
        let light = new BABYLON.HemisphericLight("light1",new BABYLON.Vector3(0, 1, 0),scene)
        light.intensity = 0.6
        light.specular = BABYLON.Color3.Black()

        let light2 = new BABYLON.DirectionalLight( "dir01", new BABYLON.Vector3(0, -0.5, -1.0), scene)
        light2.position = new BABYLON.Vector3(0, 5, 5)

        // Shadows
        let shadowGenerator = new BABYLON.ShadowGenerator(1024, light2)
        shadowGenerator.useBlurExponentialShadowMap = true
        shadowGenerator.blurKernel = 32

        var groundMaterial = new BABYLON.GridMaterial("groundMaterial", scene);
        groundMaterial.majorUnitFrequency = 1;
        groundMaterial.minorUnitVisibility = 0.1;
        groundMaterial.gridRatio = 1;
        groundMaterial.backFaceCulling = false;
        groundMaterial.mainColor = new BABYLON.Color3(0, 0, 0);
        groundMaterial.lineColor = new BABYLON.Color3(0,0, 0);
        groundMaterial.opacity = 0.2;
        
        var ground = BABYLON.Mesh.CreateGround("ground1", 20, 20, 2, scene);
        ground.material = groundMaterial;

        BABYLON.SceneLoader.ImportMesh( "",path+"data/","dummy3.glb",scene,
            function (meshes, particleSystems, skeletons) {
                scene.stopAllAnimations();
                var skeleton = skeletons[0]
                var mesh = meshes[1] 
                loadedMeshes=meshes
                meshFigure=mesh            
                showMeshes(loadedMeshes,showHuman)   
                // Removing the ability of being picked for all meshes already in scene
                scene.meshes.forEach((element) => {
                    element.isPickable = false
                });

                shadowGenerator.addShadowCaster(scene.meshes[0], true);
                for (var index = 0; index < meshes.length; index++) {
                    meshes[index].receiveShadows = false;
                }


                setBackground(background_type)
                // add skeleton
                addSkeleton(mesh,skeleton)
                // add control to modify skeleton
                addGizmo([meshes[1],meshes[2]],skeleton) 
                engine.hideLoadingUI()
                startRenderLoop(engine, canvas)
             //   let p=getPose()
             //   setPose(p)
             //   addSkeletonViewer(mesh,skeleton) 
                window.in_3d_canvas_init=false
            }
        )

    }
    /**
     * canvas can be used somewhere else
     */
    export let canvas
</script>

<canvas id="renderCanvas" {width} {height} bind:this={canvas} class="canvas"/>

<style>
    .canvas {
        width:100%;
        height:100%;
    }
    * {
        box-sizing: border-box;
    }
    /** delete this CSS: */
</style>
